import { Skeleton } from 'antd'
import { FC } from 'react'
import { useLocation } from 'react-router-dom'
import useMe from '@hooks/useMe'
import { useGetEmployeeCourseStatsQuery } from '@services/statistic'
import { User } from '@models/user'
import StatisticTemplate, {
  FinalTestResultState,
} from '@templates/StatisticTemplate'
import ContentBlock from '@organisms/ContentBlock'
import Title from '@organisms/Title'
import { Wrapper } from './styled'

const Statistic: FC = () => {
  const me = useMe()
  const { state } = useLocation()
  const { finalTestResult } = (state || {}) as {
    finalTestResult?: FinalTestResultState
  }
  const showFinalTestResult = Boolean(finalTestResult)
  const { data: stats, isLoading } = useGetEmployeeCourseStatsQuery(
    me?.id as number,
    { skip: !me }
  )
  const finalLoading = isLoading
  const { items = [] } = stats || {}
  return (
    <Wrapper>
      {!showFinalTestResult && <Title>Статистика</Title>}
      {finalLoading ? (
        <Skeleton.Button
          active
          block
          style={{
            borderRadius: 25,
            height: '62vh',
          }}
        />
      ) : showFinalTestResult ? (
        <StatisticTemplate
          user={me as unknown as User}
          stats={items}
          finalTestResult={finalTestResult}
        />
      ) : (
        <ContentBlock>
          <StatisticTemplate
            user={me as unknown as User}
            stats={items}
            finalTestResult={finalTestResult}
          />
        </ContentBlock>
      )}
    </Wrapper>
  )
}

export default Statistic
